gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

loadingScreen();

$(document).ready(function(){
	init(); 
});

function init() {
	externalInits();
	headerFunctions();
	scrollFunctions();
	ajaxFunctions();
}